import actions from './actions';

const initState = {
  weatherC: '-',
  tvInfo: null,
  loading: true,
  professionalCodeForTvIsValid: null,
  professionalCodeForTvIsValidLoading: false,
  tvInfoForProfessional: {},
  patientCalledSuccessfully: null,
};

export default function pinReducer(state = initState, action) {
  switch (action.type) {
    case actions.UPDATE_PATIENTS_LIST:
      return {
        ...state,
        tvInfo: action.payload,
        loading: false,
      };
    case actions.REQUEST_WEATHER_FOR_TV_SUCCESS:
      return {
        ...state,
        weatherC: action.payload,
      };
    case actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_WAITING:
      return {
        ...state,
        professionalCodeForTvIsValid: null,
        professionalCodeForTvIsValidLoading: true,
      };
    case actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_VALID:
      return {
        ...state,
        professionalCodeForTvIsValid: true,
        professionalCodeForTvIsValidLoading: false,
        tvInfoForProfessional: {
          ...state.tvInfoForProfessional,
          id: action.payload,
        },
      };
    case actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_ERROR:
      return {
        ...state,
        professionalCodeForTvIsValid: false,
        professionalCodeForTvIsValidLoading: false,
        tvInfoForProfessional: {},
      };
    case actions.CALL_PATIENT_TV:
      return {
        ...state,
        professionalCodeForTvIsValidLoading: true,
        patientCalledSuccessfully: null,
      };
    case actions.CALL_PATIENT_TV_SUCCESS:
      return {
        ...state,
        patientCalledSuccessfully: true,
        professionalCodeForTvIsValidLoading: false,
      };
    case actions.CALL_PATIENT_TV_ERROR:
      return {
        ...state,
        patientCalledSuccessfully: false,
        professionalCodeForTvIsValidLoading: false,
      };
    case actions.RESET_TV_CODE_ON_CACHE_FINISHED:
      return {
        ...state,
        professionalCodeForTvIsValid: null,
        professionalCodeForTvIsValidLoading: false,
        tvInfoForProfessional: {},
        patientCalledSuccessfully: null,
      };
    case actions.GET_CACHED_VALUES_FOR_TV_FINISHED:
      return {
        ...state,
        tvInfoForProfessional: {
          ...state.tvInfoForProfessional,
          ...action.payload,
        },
      };
    case actions.GET_TV_PERMISSION_SUCCESS:
      return {
        ...state,
        tvInfoForProfessional: {
          ...state.tvInfoForProfessional,
        },
        ...action.payload,
      };
    default:
      return state;
  }
}
